<script>
  import { onMount, createEventDispatcher } from "svelte";
  import addLeadingZero from "common/utils/addLeadingZero";
  import Symbol from "./Symbol";

  export let value = 0;
  export let size = 1.5;
  export let color = "#333";

  let usersSize = size;

  const dispatch = createEventDispatcher();

  const now = new Date().getTime();

  let timeLeft = value;
  let timerId = null;
  let innerWidth = 0;

  $: size =
    innerWidth < 600
      ? usersSize / 3
      : innerWidth < 900
      ? usersSize / 2
      : innerWidth < 1200
      ? usersSize / 1.5
      : usersSize;

  onMount(() => {
    startTimer();
  });

  function onTimesUp() {
    dispatch("stop");
    window.location.reload(1); // Hardcode
    clearInterval(timerId);
  }

  function startTimer() {
    if (timeLeft <= 0) return onTimesUp();
    timerId = setInterval(() => {
      timeLeft = timeLeft - 1000;

      if (timeLeft <= 0) {
        onTimesUp();
      }
    }, 1000);
  }

  function formatTime(time) {
    var seconds = Math.floor((time / 1000) % 60);
    var minutes = Math.floor((time / 1000 / 60) % 60);
    var hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    var days = Math.floor(time / (1000 * 60 * 60 * 24));

    let formatted = "";
    if (days > 0) formatted += `${days}d `;

    if (time <= 0) {
      return "[==]";
    }
    return (
      formatted +
      `${addLeadingZero(hours)}:${addLeadingZero(minutes)}:${addLeadingZero(
        seconds
      )}`
    );
  }
</script>

<style>

</style>

<svelte:window bind:innerWidth />

{#each formatTime(timeLeft) as symbol}
  <Symbol value={symbol} {size} {color} />
{/each}
